import Honeybadger from '@honeybadger-io/js'
import { isEditorLoggedIn } from 'scrivito'

export function configureHoneybadger() {
  Honeybadger.configure({
    apiKey: import.meta.env.HONEYBADGER_API_KEY,
    environment: environment(),
    revision: import.meta.env.HONEYBADGER_REVISION,
  })
  setContext()
}

function environment() {
  const { origin } = window.location

  if (origin.endsWith('//edit-neocrm.justrelate.com')) return 'production'
  else if (origin.endsWith('//edit.neodxp.com')) return 'production'
  else if (origin.endsWith('.justrelate.com')) return 'beta'
  else if (origin.endsWith('.pages.dev')) return 'preview'
  else return 'development'
}

async function setContext() {
  const editMode = isEditorLoggedIn()

  Honeybadger.setContext({ edit: editMode })
}
